import { useChat } from '../context/ChatContext';

// 화면 우측하단에 항상 고정으로 떠있는 사내 메신저 버튼(아이콘 + "사내 메신저" 글자 + 안읽음
// 숫자 배지). 누르면 좌측 대화상대 트리 + 우측 대화 화면이 하나로 합쳐진 사내 메신저 창
// (ChatMainWindow)이 열리고 닫힌다. 새 메시지가 오면 이 버튼 바로 위에 보낸사람(부서 직급
// 이름)과 내용을 5초간 미리보기로 보여준다(flashPreview) — 숫자 배지 자체는 그 대화를 실제로
// 읽기 전까지 계속 남아있어 "확인 전까지 유지"되는 알림 역할을 한다. 채팅창이 열려있어도 이
// 버튼은 계속 보이며, 이때 채팅창은 이 버튼 바로 위에 떠서 겹치지 않는다(ChatMainWindow 참고).

// 뷰포트(브라우저 화면) 오른쪽 끝에서부터의 고정 거리(px) — 처음 접속하면 항상 브라우저
// 우측 하단 구석에 자리잡는다. 메신저 창(ChatMainWindow.js)도 이 값을 그대로 가져다 써서,
// 버튼을 눌러 창이 열렸을 때 버튼의 우측 끝단과 창의 우측 끝단이 항상 일치한다
// (position:fixed 요소끼리 같은 right 값을 쓰면 너비가 달라도 오른쪽 끝은 자동으로 맞춰짐).
export const CHAT_RIGHT_PX = 20;

export default function ChatSidebarMenu() {
  const chat = useChat();
  if (!chat) return null;

  return (
    <div style={{ position:'fixed', bottom:20, right:CHAT_RIGHT_PX, zIndex:4000 }}>
      {chat.flashPreview && (
        <div onClick={chat.openFromFlash}
          style={{ position:'absolute', bottom:'100%', right:0, marginBottom:10, width:240,
            background:'#fff', borderRadius:10, boxShadow:'0 8px 24px rgba(0,0,0,0.25)',
            padding:'10px 12px', cursor:'pointer' }}>
          <button onClick={e => { e.stopPropagation(); chat.dismissFlash(); }}
            style={{ position:'absolute', top:6, right:8, background:'none', border:'none',
              fontSize:12, color:'#aaa', cursor:'pointer' }}>✕</button>
          <div style={{ fontSize:11, fontWeight:700, color:'#185FA5', marginBottom:3, paddingRight:14 }}>
            {chat.flashPreview.sender}
          </div>
          <div style={{ fontSize:12, color:'#555', overflow:'hidden', textOverflow:'ellipsis',
            display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>
            {chat.flashPreview.preview}
          </div>
        </div>
      )}

      <button onClick={chat.toggleMainWindow} title="사내 메신저"
        style={{ display:'flex', alignItems:'center', gap:8, width:160, padding:'6px 12px',
          borderRadius:999, background:'#1e293b', border:'none', cursor:'pointer',
          boxShadow:'0 6px 20px rgba(0,0,0,0.3)', boxSizing:'border-box' }}>
        <ChatIcon />
        <span style={{ color:'#fff', fontSize:14, fontWeight:700, whiteSpace:'nowrap' }}>사내 메신저</span>
        {chat.unreadTotal > 0 && (
          <span style={{ marginLeft:'auto', background:'#dc2626', color:'#fff', fontSize:11, fontWeight:700,
            borderRadius:10, minWidth:18, height:18, padding:'0 5px', display:'flex',
            alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            {chat.unreadTotal > 99 ? '99+' : chat.unreadTotal}
          </span>
        )}
      </button>
    </div>
  );
}

// 말풍선 아이콘 + 우하단의 작은 색색 배지(사내 메신저 = AI가 함께하는 대화창이라는 느낌을 주는
// 장식용 포인트)로 구성된 버튼 아이콘. 아이콘 뒤 원형 배경은 제거하고 말풍선만 표시한다.
function ChatIcon() {
  return (
    <span style={{ position:'relative', width:34, height:34, flexShrink:0 }}>
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
        <path d="M9 13a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3h-6.5L11 26v-4H12a3 3 0 01-3-3v-6z" fill="#fff" />
      </svg>
      <svg width="14" height="14" viewBox="0 0 14 14" style={{ position:'absolute', bottom:-2, right:-2 }}>
        <circle cx="7" cy="7" r="7" fill="#fff" />
        <circle cx="7" cy="4.5" r="2.4" fill="#F4A340" />
        <circle cx="9.7" cy="8.5" r="2.4" fill="#7B61FF" />
        <circle cx="4.3" cy="8.5" r="2.4" fill="#2FB8AC" />
      </svg>
    </span>
  );
}